import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/jkulkarni01'
      className='link footer__link'
    >
      Made with ❤️ by Jui Kulkarni
    </a>
  </footer>
)

export default Footer
